/* ============================================
   HOIAN STUDIO — Theme JS
   ============================================ */

(function () {
  'use strict';

  /* ---------- NAV SCROLL ---------- */
  const navbar = document.getElementById('navbar');
  if (navbar) {
    let ticking = false;
    function updateNav() {
      if (window.scrollY > 80) {
        navbar.classList.add('nav-scrolled');
      } else {
        navbar.classList.remove('nav-scrolled');
      }
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(updateNav);
        ticking = true;
      }
    }, { passive: true });
  }

  /* ---------- MOBILE MENU ---------- */
  const navToggle = document.getElementById('navToggle');
  const navLinks = document.getElementById('navLinks');
  if (navToggle && navLinks) {
    navToggle.addEventListener('click', function () {
      const isOpen = navLinks.classList.toggle('open');
      navToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
    navLinks.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        navLinks.classList.remove('open');
        navToggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ---------- SEARCH DRAWER ---------- */
  const searchTrigger = document.querySelectorAll('[data-search-open]');
  const searchDrawer = document.getElementById('searchDrawer');
  const searchClose = document.getElementById('searchClose');
  const searchInput = document.getElementById('searchInput');

  function openSearch() {
    if (!searchDrawer) return;
    searchDrawer.classList.add('open');
    searchDrawer.setAttribute('aria-hidden', 'false');
    setTimeout(function () { if (searchInput) searchInput.focus(); }, 400);
  }
  function closeSearch() {
    if (!searchDrawer) return;
    searchDrawer.classList.remove('open');
    searchDrawer.setAttribute('aria-hidden', 'true');
  }
  searchTrigger.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      openSearch();
    });
  });
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSearch();
  });

  /* ---------- CART DRAWER ---------- */
  const cartTrigger = document.querySelectorAll('[data-cart-open]');
  const cartDrawer = document.getElementById('cartDrawer');
  const cartClose = document.getElementById('cartClose');
  const cartOverlay = document.getElementById('cartOverlay');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    if (cartOverlay) cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (cartOverlay) cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  cartTrigger.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      openCart();
    });
  });
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('open')) closeCart();
  });

  /* ---------- CART AJAX ---------- */
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    const symbol = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '$';
    return symbol + amount;
  }

  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        updateCartCount(cart.item_count);
      })
      .catch(function (err) { console.error('Cart fetch failed:', err); });
  }

  function updateCartCount(count) {
    const counters = document.querySelectorAll('[data-cart-count]');
    counters.forEach(function (el) { el.textContent = count; });
  }

  function renderCart(cart) {
    const body = document.getElementById('cartBody');
    const footer = document.getElementById('cartFooter');
    if (!body) return;

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="cart-empty">Your cart is empty.</div>';
      if (footer) footer.style.display = 'none';
      return;
    }

    let html = '';
    cart.items.forEach(function (item) {
      const img = item.featured_image && item.featured_image.url ? item.featured_image.url : '';
      html += '<div class="cart-item" data-key="' + item.key + '">';
      if (img) {
        html += '<img class="cart-item-img" src="' + img + '" alt="' + item.title + '" loading="lazy">';
      } else {
        html += '<div class="cart-item-img"></div>';
      }
      html += '<div>';
      html += '<div class="cart-item-name">' + item.product_title + '</div>';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        html += '<div class="cart-item-meta">' + item.variant_title + '</div>';
      }
      html += '<div class="cart-item-meta">Qty: ' + item.quantity + '</div>';
      html += '</div>';
      html += '<div class="cart-item-price">' + formatMoney(item.final_line_price) + '</div>';
      html += '</div>';
    });
    body.innerHTML = html;

    if (footer) {
      footer.style.display = 'block';
      const subtotal = footer.querySelector('[data-cart-subtotal]');
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    }
  }

  // Initial fetch on page load to set count
  if (document.querySelector('[data-cart-count]')) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () { /* silent */ });
  }

  /* ---------- PRODUCT FORM (AJAX ADD) ---------- */
  document.querySelectorAll('.js-product-form, [data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = form.querySelector('[data-add-btn]');
      const original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

      const formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status && data.status !== 200) {
            if (btn) { btn.disabled = false; btn.textContent = original; }
            alert(data.description || 'Could not add to cart.');
            return;
          }
          if (btn) { btn.disabled = false; btn.textContent = original; }
          openCart();
        })
        .catch(function (err) {
          console.error(err);
          if (btn) { btn.disabled = false; btn.textContent = original; }
        });
    });
  });

  /* ---------- PRODUCT GALLERY: scroll-snap carousel ---------- */
  (function () {
    const track = document.querySelector('[data-gallery-track]');
    if (!track) return;
    const slides = track.querySelectorAll('.product-gallery-slide');
    const thumbs = document.querySelectorAll('.product-thumb[data-thumb-index]');
    if (slides.length < 1) return;

    function pauseInactiveVideos(activeIdx) {
      slides.forEach(function (slide, i) {
        if (i === activeIdx) return;
        const video = slide.querySelector('video');
        if (video && !video.paused) video.pause();
        // Stop YouTube/Vimeo iframes by reloading their src (cuts off audio)
        const iframe = slide.querySelector('iframe');
        if (iframe && iframe.src && i !== activeIdx) {
          const src = iframe.src;
          iframe.src = src;
        }
      });
    }

    // Khi user vuốt track, detect slide hiện tại và sync thumbnail
    let scrollDebounce;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollDebounce);
      scrollDebounce = setTimeout(function () {
        const idx = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach(function (t, i) {
          t.classList.toggle('active', i === idx);
        });
        // Auto-scroll thumb row để thumb active luôn nằm trong tầm nhìn
        const activeThumb = thumbs[idx];
        if (activeThumb && activeThumb.scrollIntoView) {
          activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
        // Pause videos không phải slide hiện tại (tránh phát audio nền)
        pauseInactiveVideos(idx);
      }, 80);
    }, { passive: true });

    // Click thumbnail → scroll track tới slide đó
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        const idx = parseInt(thumb.getAttribute('data-thumb-index'), 10);
        if (isNaN(idx)) return;
        track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
      });
    });
  })();

  /* ---------- PRODUCT OPTIONS + VARIANT SWITCHING ---------- */
  document.querySelectorAll('[data-variants-json]').forEach(function (script) {
    const form = script.closest('form');
    if (!form) return;

    let variants;
    try { variants = JSON.parse(script.textContent); } catch (e) { return; }

    const optionGroups = form.querySelectorAll('[data-option-group]');
    const variantInput = form.querySelector('[data-variant-input]');
    const addBtn = form.querySelector('[data-add-btn]');
    const productPage = form.closest('.product-page');
    const priceEl = productPage ? productPage.querySelector('.price-current') : null;
    const skuEl = productPage ? productPage.querySelector('[data-variant-sku]') : null;
    const stockEl = productPage ? productPage.querySelector('.product-stock') : null;
    const mainImg = productPage ? productPage.querySelector('[data-main-image]') : null;

    function getSelectedOptions() {
      return Array.from(optionGroups).map(function (group) {
        const checked = group.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (val, i) { return val === opts[i]; });
      });
    }

    function formatMoney(cents) {
      const dollars = (cents / 100);
      try {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(dollars);
      } catch (e) {
        return '$' + dollars.toFixed(2);
      }
    }

    function updateOptionAvailability() {
      const selected = getSelectedOptions();
      optionGroups.forEach(function (group, gIdx) {
        const values = group.querySelectorAll('[data-option-value]');
        values.forEach(function (val) {
          const candidate = selected.slice();
          candidate[gIdx] = val.getAttribute('data-value');
          const match = findVariant(candidate);
          if (!match || !match.available) {
            val.classList.add('unavailable');
          } else {
            val.classList.remove('unavailable');
          }
        });
      });
    }

    function updateUI() {
      const opts = getSelectedOptions();
      const variant = findVariant(opts);

      // Update inline "selected value" labels
      optionGroups.forEach(function (group, gIdx) {
        const label = group.querySelector('[data-selected-value]');
        if (label && opts[gIdx]) label.textContent = opts[gIdx];
      });

      if (!variant) {
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = 'Unavailable';
        }
        return;
      }

      if (variantInput) variantInput.value = variant.id;

      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (skuEl) skuEl.textContent = variant.sku || '';

      // Update URL with variant param (history)
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}

      // Update featured image if variant has one
      if (mainImg && variant.featured_image) {
        const src = variant.featured_image.src || variant.featured_image;
        if (src && typeof src === 'string') mainImg.src = src;
      }

      // Update add-to-cart button + stock label
      if (variant.available) {
        if (addBtn) {
          addBtn.disabled = false;
          const orig = addBtn.getAttribute('data-original-label') || addBtn.textContent.trim();
          if (!addBtn.getAttribute('data-original-label')) addBtn.setAttribute('data-original-label', orig);
          addBtn.textContent = orig;
        }
        if (stockEl) {
          stockEl.classList.remove('sold-out');
          if (variant.inventory_quantity && variant.inventory_quantity <= 10 && variant.inventory_quantity > 0) {
            stockEl.classList.remove('in-stock'); stockEl.classList.add('low-stock');
          } else {
            stockEl.classList.remove('low-stock'); stockEl.classList.add('in-stock');
          }
        }
      } else {
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = 'Sold Out';
        }
        if (stockEl) {
          stockEl.classList.remove('in-stock', 'low-stock');
          stockEl.classList.add('sold-out');
        }
      }

      updateOptionAvailability();
    }

    // Wire up option clicks
    optionGroups.forEach(function (group) {
      const values = group.querySelectorAll('[data-option-value]');
      values.forEach(function (val) {
        val.addEventListener('click', function (e) {
          if (val.classList.contains('unavailable')) {
            // Still allow selection so user sees "unavailable" feedback in button
          }
          values.forEach(function (v) { v.classList.remove('selected'); });
          val.classList.add('selected');
          const input = val.querySelector('input');
          if (input) input.checked = true;
          updateUI();
        });
      });
    });

    // Initial availability paint
    updateOptionAvailability();
  });

  // Fallback for product pages without variants JSON (single-variant products)
  document.querySelectorAll('[data-option-group]').forEach(function (group) {
    if (group.closest('form') && group.closest('form').querySelector('[data-variants-json]')) return;
    const values = group.querySelectorAll('[data-option-value]');
    values.forEach(function (val) {
      val.addEventListener('click', function () {
        values.forEach(function (v) { v.classList.remove('selected'); });
        val.classList.add('selected');
        const input = val.querySelector('input');
        if (input) input.checked = true;
      });
    });
  });

  /* ---------- REVIEWS EMPTY STATE ---------- */
  // Hide fallback empty state when a real reviews app populates its widget
  ['shopify-product-reviews', 'jdgm-widget', 'yotpo-main-widget'].forEach(function (cls) {
    const el = document.querySelector(cls === 'shopify-product-reviews' ? '#' + cls : '.' + cls);
    if (el && el.children.length > 0) {
      const empty = document.querySelector('[data-reviews-empty]');
      if (empty) empty.style.display = 'none';
    }
  });

  /* ---------- QUANTITY ---------- */
  document.querySelectorAll('[data-qty-wrap]').forEach(function (wrap) {
    const input = wrap.querySelector('input');
    const minus = wrap.querySelector('[data-qty-minus]');
    const plus = wrap.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      const v = Math.max(1, parseInt(input.value || 1, 10) - 1);
      input.value = v;
    });
    if (plus) plus.addEventListener('click', function () {
      const v = parseInt(input.value || 1, 10) + 1;
      input.value = v;
    });
  });

  /* ---------- SIZE CHART MODAL ---------- */
  const sizeChartModal = document.querySelector('[data-size-chart-modal]');
  if (sizeChartModal) {
    const openTriggers = document.querySelectorAll('[data-size-chart-open]');
    const closeTriggers = document.querySelectorAll('[data-size-chart-close]');

    function openSizeChart() {
      sizeChartModal.classList.add('open');
      sizeChartModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeSizeChart() {
      sizeChartModal.classList.remove('open');
      sizeChartModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    openTriggers.forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); openSizeChart(); });
    });
    closeTriggers.forEach(function (btn) {
      btn.addEventListener('click', closeSizeChart);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sizeChartModal.classList.contains('open')) closeSizeChart();
    });
  }

  /* ---------- SCROLL REVEAL ---------- */
  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -10% 0px' });
    reveals.forEach(function (r) { obs.observe(r); });
  } else {
    reveals.forEach(function (r) { r.classList.add('visible'); });
  }

  /* ---------- LAZY LOAD FALLBACK ---------- */
  if ('loading' in HTMLImageElement.prototype === false) {
    const images = document.querySelectorAll('img[loading="lazy"]');
    if ('IntersectionObserver' in window) {
      const imgObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            const img = e.target;
            if (img.dataset.src) img.src = img.dataset.src;
            imgObs.unobserve(img);
          }
        });
      });
      images.forEach(function (img) { imgObs.observe(img); });
    }
  }

  /* ---------- LISTEN FOR EXTERNAL ADD-TO-CART ---------- */
  document.addEventListener('cart:open', openCart);
  document.addEventListener('cart:refresh', refreshCart);

})();
